import { render, staticRenderFns } from "./acpagesTail.vue?vue&type=template&id=244adeba&scoped=true&"
import script from "./acpagesTail.vue?vue&type=script&lang=js&"
export * from "./acpagesTail.vue?vue&type=script&lang=js&"
import style0 from "./acpagesTail.vue?vue&type=style&index=0&id=244adeba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244adeba",
  null
  
)

export default component.exports